import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { BankAccountsCollection, } from "@bundles/UIAppBundle/collections";
import { Routes } from "@bundles/UIAppBundle";
import { DeleteOutlined, EditOutlined, EyeOutlined, UnorderedListOutlined, } from "@ant-design/icons";
import { AntTableSmart } from "@bluelibs/x-ui-admin";
import * as Ant from "antd";
import { features } from "../../config/features";
import { BankAccountList } from "../../config/BankAccountList";
import { useAppGuardian } from "@bundles/UIAppBundle/services/AppGuardian";
import { UserRole } from "@root/api.types";
export class BankAccountsAntTableSmart extends AntTableSmart {
    constructor() {
        super(...arguments);
        this.collectionClass = BankAccountsCollection;
    }
    getBody() {
        return BankAccountList.getRequestBody();
    }
    getColumns() {
        var _a, _b;
        const { state } = useAppGuardian();
        const roles = (_b = (_a = state === null || state === void 0 ? void 0 : state.user) === null || _a === void 0 ? void 0 : _a.roles) !== null && _b !== void 0 ? _b : [];
        const isAdmin = roles.includes(UserRole.ADMIN) || roles.includes(UserRole.SHAREHOLDER);
        const list = this.container.get(BankAccountList);
        list.build();
        return isAdmin
            ? [...list.rest(), this.getActionsColumn()]
            : [...list.rest()];
    }
    getActionsColumn() {
        return {
            title: this.i18n.t("generics.list_actions"),
            key: "actions",
            fixed: "right",
            width: 100,
            render: (_, model) => {
                return (_jsx(Ant.Popover, Object.assign({ placement: "bottomRight", content: _jsxs("div", Object.assign({ style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 4,
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                        } }, { children: [_jsxs(Ant.Button, Object.assign({ type: "text", style: {
                                    width: "100%",
                                }, onClick: () => {
                                    this.router.go(Routes.BANK_ACCOUNTS_VIEW, {
                                        params: { id: model._id.toString() },
                                    });
                                } }, { children: [_jsx(EyeOutlined, {}, void 0), this.i18n.t("generics.view")] }), void 0), _jsxs(Ant.Button, Object.assign({ type: "text", style: { width: "100%" }, onClick: () => {
                                    this.router.go(Routes.BANK_ACCOUNTS_EDIT, {
                                        params: { id: model._id.toString() },
                                    });
                                } }, { children: [_jsx(EditOutlined, {}, void 0), this.i18n.t("generics.edit")] }), void 0), _jsx(Ant.Popconfirm, Object.assign({ title: this.i18n.t("generics.ask_confirmation"), onConfirm: () => {
                                    this.collection.deleteOne(model._id).then(() => {
                                        this.load();
                                    });
                                }, okText: this.i18n.t("generics.delete"), cancelText: this.i18n.t("generics.cancel") }, { children: _jsxs(Ant.Button, Object.assign({ type: "text", style: { width: "100%" } }, { children: [_jsx(DeleteOutlined, {}, void 0), this.i18n.t("generics.delete")] }), void 0) }), void 0)] }), void 0), style: { backgroundColor: "black !important" } }, { children: _jsx(Ant.Button, Object.assign({ type: "primary" }, { children: _jsx(UnorderedListOutlined, {}, void 0) }), void 0) }), void 0));
            },
        };
    }
    getSortMap() {
        return BankAccountList.getSortMap();
    }
    getActionItems() {
        const actions = [];
        if (features.view) {
            actions.push({
                label: this.i18n.t("generics.view"),
                icon: _jsx(EyeOutlined, {}, void 0),
                action: (model) => {
                    this.router.go(Routes.BANK_ACCOUNTS_VIEW, {
                        params: { id: model._id.toString() },
                    });
                },
            });
        }
        if (features.edit) {
            actions.push({
                label: this.i18n.t("generics.edit"),
                icon: _jsx(EditOutlined, {}, void 0),
                action: (model) => {
                    this.router.go(Routes.BANK_ACCOUNTS_EDIT, {
                        params: { id: model._id.toString() },
                    });
                },
            });
        }
        if (features.delete) {
            actions.push({
                label: this.i18n.t("generics.delete"),
                icon: _jsx(DeleteOutlined, {}, void 0),
                confirm: this.i18n.t("generics.ask_confirmation"),
                action: (model) => {
                    this.collection.deleteOne(model._id).then(() => {
                        this.load();
                    });
                },
            });
        }
        return actions;
    }
}
